import * as tslib_1 from "tslib";
import BlockedDomainsOption from 'owa-blocked-domains-option/lib/BlockedDomainsOption';
import BlockedSendersOption from 'owa-blocked-senders-option/lib/BlockedSendersOption';
import { initMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import SafeMailingListsOption from 'owa-safe-mailing-lists-option/lib/SafeMailingListsOption';
import SafeSendersOption from 'owa-safe-senders-option/lib/SafeSendersOption';
import { trace } from 'owa-trace';
var junkEmailSubCategory = {
    key: 'junkEmail',
    titleStringKey: 'optionSubcategory_junkEmail',
    options: [
        BlockedSendersOption,
        BlockedDomainsOption,
        SafeSendersOption,
        SafeMailingListsOption,
    ],
    onSelected: function () {
        return loadMailboxJunkEmailConfiguration();
    },
};
export default junkEmailSubCategory;
function loadMailboxJunkEmailConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, initMailboxJunkEmailConfiguration()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    trace.warn(e_1.message || 'loadMailboxJunkEmailConfiguration failed');
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=junkEmailSubCategory.js.map